<template>
    <transition name="fade" mode="out-in">
      <v-container fluid pa-0 v-if="!speedTestDone" fill-height>
        <v-row justify="center">
          <v-col cols="12">
            <page-heading :text="$t('views.speedtest.checking')" text-center></page-heading>
          </v-col>
          <v-col cols="12">
            <v-progress-linear :value="speedtest.progress * 100"
                               background-color="rgba(255,255,255,0.5)"
                               background-opacity="0.3"
                               color="rgba(255,255,255,0.4)"
                               height="15"
            ></v-progress-linear>
          </v-col>
        </v-row>
      </v-container>
      <SpeedTestFailed v-else
                       :upload-speed="speedtest.uploadSpeed"
                       :download-speed="speedtest.downloadSpeed"
                       @test="test()"
                       @accept="accept()"
      ></SpeedTestFailed>
    </transition>
</template>

<script>
    import PageHeading from "../../components/framework/PageHeading";
    import assessmentstate from "../../router/assessmentstate";
    import SpeedTestFailed from "../../components/framework/speedtest/SpeedTestFailed";

    export default {
      components: {
        PageHeading,SpeedTestFailed
      },
      path: '/welcome/connection',
      name: "ConnectionSpeed",
      data: () => ({}),
      computed: {
        speedtest() {
          return this.$store.state.speedtest;
        },
        speedTestDone() {
          return !!this.speedtest.lastRunAt && !this.speedtest.active;
        },
        passed(){
          return this.speedtest.passed;
        }
      },
      mounted() {
        if (!this.speedtest.lastRunAt && !this.speedtest.active && !this.speedtest.passed) {
          this.test();
        } else if (this.speedtest.passed) {
          this.navigate();
        }
        this.$watch('passed',()=>{
           if(this.passed && this.speedTestDone){
             this.navigate();
           }
        });
      },
      methods: {
        accept() {
          this.$store.dispatch('speedtest/accept').then(() => {
            this.navigate();
          });
        },
        navigate() {
          assessmentstate((route) => {
            this.$router.replace(route);
          });
        },
        test(){
          this.$store.dispatch('speedtest/start');
        }
      }
    }
</script>

<style scoped>

</style>